import { useHasValueChanged } from "hooks"
import { Icon, IconCertified, PieChart } from "materia"
import type { ReactNode } from "react"
import { modifiers } from "ui-tools"
import s from "./JourneyHeader.module.scss"

export const JourneyHeader = ({ children }: { children: ReactNode }) => {
  return <div className={s.header}>{children}</div>
}

JourneyHeader.Title = ({ title }: { title: string | null }) => {
  if (title) return <h2 className={s.header__title}>{title}</h2>
}

JourneyHeader.Status = ({
  progressPercentage,
  isCertified,
  isLocked,
  lockedByJourneys,
}: {
  progressPercentage: number
  isCertified: boolean
  isLocked: boolean
  lockedByJourneys: string[]
}) => {
  const isInProgress = progressPercentage > 0 && !isCertified

  return (
    <div className={s.header__status}>
      {isInProgress && (
        <PieChart
          progressPercentage={progressPercentage}
          size="medium"
          title={`This journey is ${progressPercentage}% completed`}
        />
      )}

      {isCertified && <IconCertified size="large" />}

      {/* "Locked" status is absolutely positioned above all other statuses
      so it can have a fancy animation when Journey gets unlocked! */}
      <Locked isLocked={isLocked} lockedByJourneys={lockedByJourneys} />
    </div>
  )
}

type LockedProps = { isLocked: boolean; lockedByJourneys: string[] }
const Locked = ({ isLocked, lockedByJourneys }: LockedProps) => {
  const enableAnimations = useHasValueChanged(isLocked)
  const hasLockedByJourneys = lockedByJourneys.length > 0
  const title = hasLockedByJourneys
    ? `Complete "${lockedByJourneys.join('", "')}" to unlock journey`
    : undefined

  return (
    <div
      className={modifiers(s, "header__locked", {
        isLocked,
        enableAnimations,
      })}
      title={title}
    >
      <Icon icon="Lock" />
    </div>
  )
}

JourneyHeader.Skeleton = () => {
  return (
    <div className={s.header}>
      <span />
      <div className={s.skeleton__title} />
      <span />
    </div>
  )
}
